/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {
    Container
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFolderPlus} from '@fortawesome/free-solid-svg-icons';
import Settings from '../../custom-classes/settings';
import FormSubscriptionFull from '../forms/form-subscription-full';

/**
 * It's the window where you can handle the subscriptions details. It only includes the form
 */
class SubscriptionManager extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            successfulRegistration: true,
            checked: false,
            lineChartData: null,
            languages: [],
            didMount: false,
            stripeApiKey: Settings.getStripeToken(),
            stripeUpdatePayment: false,
            subTokenStripe: null,
            userId: null,
            planId: null,
            submitButtonAvailable: false,
            loading: false,
            showModal: false,
            propsModal: null,
            subscriptionId : null,
            isEdit: false,
            showCancellationModal: false,
            disabledCancellation: false,
            cancelledInmediatetly: false
        };
        this.props.addTranslation(global);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.setState({didMount: true});
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Renders the main page
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faFolderPlus}/>{' '}
                            <Translate id="subscriptions.subscriptions-management"/>
                        </h2>
                        <small className="white-text">
                            <Translate id="subscriptions.subscriptions-management-instructions"/>
                        </small>
                        <hr/>
                        <FormSubscriptionFull data={this.state}/>
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    };
}

export default withLocalize(SubscriptionManager);